import { Select } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { TextEllipsisState } from '../../hooks/DataTable/features';

export interface ActionBarSettingsTextEllipsisSelectProps {
  onTextEllipsisChange: (value: TextEllipsisState) => void;
  textEllipsis: TextEllipsisState;
}

export default function ActionBarSettingsTextEllipsisSelect(
  props: ActionBarSettingsTextEllipsisSelectProps,
) {
  const { t } = useTranslation();
  const { textEllipsis, onTextEllipsisChange } = props;

  const handleTextEllipsisChange = (value: string) => {
    onTextEllipsisChange(value === 'ellipsis');
  };

  return (
    <Select
      size="md"
      options={[
        { value: 'ellipsis', text: t('ui:settings.text_ellipsis') },
        { value: 'wrap', text: t('ui:settings.text_wrap') },
      ]}
      value={textEllipsis ? 'ellipsis' : 'wrap'}
      onChange={handleTextEllipsisChange}
    />
  );
}
